import { render, staticRenderFns } from "./mailSubscription.vue?vue&type=template&id=4679a634&scoped=true"
import script from "./mailSubscription.vue?vue&type=script&lang=js"
export * from "./mailSubscription.vue?vue&type=script&lang=js"
import style0 from "./mailSubscription.vue?vue&type=style&index=0&id=4679a634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679a634",
  null
  
)

export default component.exports